import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgIconPlaybackRate2X = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 14, viewBox: "0 0 22 14", fill: "none", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.916327 14C0.697825 14 0.520695 13.8229 0.520695 13.6044V11.4887C0.520695 11.3708 0.573292 11.259 0.66415 11.1838L5.67291 7.04046C6.01459 6.75723 6.30682 6.49197 6.5496 6.2447C6.79687 5.99294 6.98569 5.73443 7.11607 5.46917C7.25094 5.20392 7.31838 4.90944 7.31838 4.58574C7.31838 4.23057 7.24195 3.9271 7.0891 3.67534C6.94073 3.42357 6.73393 3.23025 6.46867 3.09538C6.20342 2.95601 5.8977 2.88632 5.55152 2.88632C5.20535 2.88632 4.89963 2.95601 4.63438 3.09538C4.37362 3.23475 4.1713 3.43931 4.02744 3.70906C3.93529 3.88183 3.87265 4.07859 3.83953 4.29932C3.8071 4.5154 3.63451 4.69364 3.41601 4.69364H0.646578C0.428076 4.69364 0.249382 4.51623 0.263476 4.29819C0.315479 3.49366 0.52935 2.78925 0.905088 2.18497C1.34118 1.48362 1.95711 0.944124 2.75287 0.566474C3.54863 0.188825 4.48152 0 5.55152 0C6.6575 0 7.61511 0.177585 8.42436 0.532756C9.2381 0.88343 9.86527 1.37797 10.3059 2.01638C10.7509 2.65479 10.9735 3.40334 10.9735 4.26204C10.9735 4.79255 10.8633 5.32081 10.643 5.84682C10.4227 6.36834 10.0271 6.94605 9.45615 7.57996C8.88518 8.21387 8.07368 8.96917 7.02166 9.84586L5.74669 10.9083C5.73413 10.9188 5.72686 10.9343 5.72686 10.9507C5.72686 10.9811 5.75153 11.0058 5.78197 11.0058H10.7262C10.9447 11.0058 11.1219 11.1829 11.1219 11.4014V13.6044C11.1219 13.8229 10.9447 14 10.7262 14H0.916327Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M14.8341 3.64162C14.9873 3.64162 15.1268 3.73013 15.192 3.86879L16.2471 6.11069C16.388 6.41018 16.8125 6.41451 16.9595 6.11797L18.0782 3.86151C18.145 3.72682 18.2824 3.64162 18.4327 3.64162H21.2216C21.5207 3.64162 21.7117 3.96071 21.5703 4.22428L19.2072 8.62927C19.1432 8.74855 19.1446 8.89228 19.211 9.01026L21.6861 13.4104C21.8344 13.6741 21.6438 14 21.3412 14H18.5866C18.4404 14 18.3062 13.9194 18.2374 13.7904L16.9504 11.3747C16.8004 11.0932 16.396 11.0958 16.2497 11.3792L15.0069 13.7859C14.939 13.9174 14.8034 14 14.6554 14H11.8533C11.55 14 11.3595 13.6728 11.5093 13.409L14.0067 9.00981C14.0736 8.89211 14.0756 8.74841 14.0121 8.62888L11.6714 4.22287C11.5314 3.95935 11.7224 3.64162 12.0208 3.64162H14.8341Z", fill: props.fill }));
});
export default SvgIconPlaybackRate2X;
